import Handlebars from "handlebars";

/**
 * Client-side Handlebars render for the live preview. Mirrors the server's
 * `HandlebarsTemplateRenderer` exactly — plain `Handlebars.compile` with
 * `noEscape: true`, no custom helpers/partials — so the rendered output is
 * byte-identical to what the dispatcher produces. Rendering here (instead of
 * the `POST …/preview` endpoint) lets the operator preview the UNSAVED editor
 * buffer without first creating a version.
 *
 * `noEscape: true` matches the server: the stored body IS the raw content
 * (HTML for emails); Handlebars must not HTML-escape interpolated values, or
 * the preview would diverge from the delivered bytes.
 */

export interface RenderOk {
  readonly ok: true;
  readonly subject: string | null;
  readonly body: string;
}

export interface RenderError {
  readonly ok: false;
  /** Handlebars parse/compile message (often includes the line number). */
  readonly error: string;
}

export type RenderResult = RenderOk | RenderError;

export function renderTemplate(
  template: { subject: string | null; body: string },
  data: Record<string, unknown>,
): RenderResult {
  try {
    const subject =
      template.subject === null
        ? null
        : Handlebars.compile(template.subject, { noEscape: true })(data);
    const body = Handlebars.compile(template.body, { noEscape: true })(data);
    return { ok: true, subject, body };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : String(err) };
  }
}
